import { LegacyParkingShiftRevenueRow } from '../api/paymentApi';
import { formatCasualParkingDateTime } from './casualParkingInvoice';
import { formatVndAmount, formatVndInput } from './vndFormat';

export type LegacyShiftTurnCountLine = {
  loaiThe: string;
  soXeVao: number;
  soXeRa: number;
  soTien: number;
};

export function parseLegacyShiftTurnCountDetail(
  json: string | null | undefined,
): LegacyShiftTurnCountLine[] {
  if (!json?.trim()) return [];
  try {
    const parsed = JSON.parse(json) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((item) => {
        if (!item || typeof item !== 'object') return null;
        const row = item as Record<string, unknown>;
        const loaiThe = String(row.LoaiThe ?? row.loaiThe ?? '').trim();
        if (!loaiThe) return null;
        return {
          loaiThe,
          soXeVao: Number(row.SoXeVao ?? row.soXeVao ?? 0) || 0,
          soXeRa: Number(row.SoXeRa ?? row.soXeRa ?? 0) || 0,
          soTien: Number(row.SoTien ?? row.soTien ?? 0) || 0,
        };
      })
      .filter((line): line is LegacyShiftTurnCountLine => line != null);
  } catch {
    return [];
  }
}

export type CasualParkingFeeInitialValues = {
  billingPeriod?: string;
  revenueFrom?: string;
  revenueTo?: string;
  machineAmount?: string;
  actualAmount?: string;
  notes?: string;
};

function parseShiftDate(value: string | null): Date | null {
  if (!value?.trim()) return null;
  const normalized = value.includes('T') ? value : value.replace(' ', 'T');
  const d = new Date(normalized);
  return Number.isNaN(d.getTime()) ? null : d;
}

function billingPeriodFromDate(date: Date | null): string | undefined {
  if (!date) return undefined;
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${month}/${date.getFullYear()}`;
}

export function buildCasualParkingInitialFromShiftRevenue(
  row: LegacyParkingShiftRevenueRow,
): CasualParkingFeeInitialValues {
  const fromDate =
    parseShiftDate(row.startedAt) ?? parseShiftDate(row.startedAtDisplay);
  const toDate = parseShiftDate(row.endedAt) ?? parseShiftDate(row.endedAtDisplay);
  const amount = Math.round(row.totalAmount);

  const parts = [
    `Ca trực ${row.shiftCode}`,
    row.staffName ? `NV: ${row.staffName}` : null,
    `Vào ${row.totalEntries} / Ra ${row.totalExits} / Tồn ${row.totalOnSite}`,
  ].filter(Boolean);

  return {
    billingPeriod: billingPeriodFromDate(toDate ?? fromDate),
    revenueFrom: formatCasualParkingDateTime(fromDate ?? row.startedAt ?? row.startedAtDisplay),
    revenueTo: formatCasualParkingDateTime(toDate ?? row.endedAt ?? row.endedAtDisplay),
    machineAmount: amount > 0 ? formatVndInput(String(amount)) : '',
    actualAmount: amount > 0 ? formatVndInput(String(amount)) : '',
    notes: parts.join(' · '),
  };
}
